import React from 'react';
import { Col, Form, Radio, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Text } from '@/components/Typography';

interface RadioOption {
	id: string;
	description: string;
}

interface DependentRadioFieldProps {
	label: string;
	name: (string | number)[];
	options: RadioOption[];
}

export function DependentRadioField({ label, name, options }: Readonly<DependentRadioFieldProps>): JSX.Element {
	return (
		<Row gutter={[0, 5]}>
			<Col span={24}>
				<Text strong>{label}</Text>
			</Col>
			<Col span={24}>
				<Form.Item style={{ margin: 0 }} name={name}>
					<Radio.Group>
						{options.map(({ id, description }) => (
							<Radio key={id} value={id} style={{ display: 'block', marginBottom: 8 }}>
								{I18n.get(description)}
							</Radio>
						))}
					</Radio.Group>
				</Form.Item>
			</Col>
		</Row>
	);
}
